import React from "react"
import {
    Card,
    CardBody,
} from "reactstrap";

class WorkOccupation extends React.Component {

    render() {
        
        const {
            client
        } = this.props;

        return (
            <Card>
              <CardBody>
                <div className="typography-line">
                  <h4>
                    <span>Occupation</span>
                    {client.occupation || "N/A"}
                  </h4>
                </div>
                <div className="typography-line">
                  <h4>
                    <span>Business/Company Name</span>
                    {client.companyName || "N/A"}
                  </h4>
                </div>
                <div className="typography-line">
                  <h4>
                    <span>Company Address</span>
                    {client.companyAddress || "N/A"}
                  </h4>
                </div>
                <div className="typography-line">
                  <h4>
                    <span>Contact Number/Mobile</span>
                    {client.companyContact || "N/A"}
                  </h4>
                </div>
                <div className="typography-line">
                  <h4>
                    <span>Company Email Address</span>
                    {client.companyEmail || "N/A"}
                  </h4>
                </div>
                <div className="typography-line">
                  <h4>
                    <span>Nature of Business</span>
                    {client.businessNature || "N/A"}
                  </h4>
                </div>
                <div className="typography-line">
                  <h4>
                    <span>Position Held</span>
                    {client.jobTitle || "N/A"}
                  </h4>
                </div>
                <div className="typography-line">
                  <h4>
                    <span>Years in Employment</span>
                    {client.experience || "N/A"}
                  </h4>
                </div>
              </CardBody>
            </Card>
        )
    }
}

export default WorkOccupation;